import classNames from "classnames";
import { NavItemConfig } from "../Siderbar.constant";
import styles from '../Sidebar.module.scss';
import NavItem from "./NavItem";
import CustomDropdown from "./CustomDropDown";

const RenderNavItem = ({ item, isActiveKey, isOpenKey, collapsed, handleItemClick }: { item: NavItemConfig, isActiveKey: string, isOpenKey: string, collapsed: boolean, handleItemClick: (navItem: NavItemConfig) => void; }) => {
	const hasChildren = 'children' in item && Number(item.children?.length) > 1;
	const isOpen = isOpenKey === item.key;
	const isActive = isActiveKey === item.path;

	return (
		<div key={item.key}>
			{(collapsed && hasChildren) ? <CustomDropdown {...{ isActiveKey, handleItemClick }} items={item?.children || []} TitleComp={<span className={`dropdown-title`}>
				{item.label}
			</span>}>
				<NavItem {...{ item, isActive: isOpen, isOpen, hasChildren: false, onClick:() => handleItemClick(item) }} />
			</CustomDropdown> : <>
				<NavItem {...{ item, isActive, isOpen, hasChildren, onClick: () => handleItemClick(item) }} />
				{hasChildren && (
					<div className={styles.subMenu} style={{ maxHeight: isOpen ? `${item.children!.length * 40}px` : '0px' }}>
						{item.children!.map((child) => (
							<div key={child.key}
								className={classNames(styles.navItem, { [styles['navItem--active']]: isActiveKey === child.path })}
								onClick={() => handleItemClick(child)}>
								{child.icon && <span className={styles.navItem__icon}>{child.icon}</span>}
								<span className={styles.navItem__label}>{child.label}</span>
							</div>
						))}
					</div>
				)}
			</>}
		</div>
	);
};

export default RenderNavItem;